module.exports = __webpack_public_path__ + "static/media/crossed.9e2d88e2.webp";